module.exports = __webpack_public_path__ + "static/wechat-aa662e016928b7b0ff1697b874c3d410.png";